import { CheckoutStep } from './btpay-analytics/checkout-step.enum';
import { SerializableMap } from './serializable-map.model';

const CheckoutStepUrlMap: SerializableMap<string> = {};

CheckoutStepUrlMap[CheckoutStep.PaymentDetails] = '/details';
CheckoutStepUrlMap[CheckoutStep.PaymentMethod] = '/paymentmethod';
CheckoutStepUrlMap[CheckoutStep.Review] = '/review';
CheckoutStepUrlMap[CheckoutStep.Confirmation] = '/summary';

export { CheckoutStepUrlMap };
